//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AccountAutoPricingSettingsInputs, AutoBroadcastSettings, AutoCurrencyConversionSettings, ConfirmationDialogSettingRequest, ConfirmationDialogSettingsResponse, CustomQuickFilterOfListingQuery, CustomQuickFilterOfMarketplacePaymentQuery, CustomQuickFilterOfOnSaleEventQuery, CustomQuickFilterOfPurchaseOrderQuery, CustomQuickFilterOfSaleQuery, FileDownloadInfo, FileParameter, FileResponse, InsertSellerEventConfirmationDialogSuppressionRequest, ListingGroupSettings, Marketplace, PosActionResult, PosUiActionResult, PurchaseOrderSettings, ReleaseNote, RevealMarketExternalPosSyncConfig, RevealSyncConfigOverrideInput, SellerAccount, SellerAccountFulfillmentRule, SellerAccountFulfillmentRuleDto, SellerAccountFulfillmentRulesInput, SellerEventConfirmationDialogSuppression, SellerPermissionInfo, SellerRoleInfo, SellerRoleInput, SellerSupportCase, SellerSupportCaseAttachmentRequest, SellerSupportCaseNote, SellerSupportCaseQuery, SellerSupportCaseRequest, SellerUser, SellerUserAccountInfo, SellerUserAccountInput, SellerUserInput, SellerUserRolesInput, SellerUserSetting, SyncCenterSettings, TimezoneInfo, TradeDeskPasswordResetInput, TutorialItem, TutorialItemContent, UserSetting } from './types';


export interface ISellerAccountClient {

    getCurrentUserSellerAccounts(): Promise<SellerAccount[]>;

    getConsigneeSellerAccounts(): Promise<SellerAccount[]>;

    getSellerUsersForSellerAccount(): Promise<SellerUserAccountInfo[]>;

    getSelleRolesForSellerAccount(): Promise<SellerRoleInfo[]>;

    getAllSellerPermissions(): Promise<SellerPermissionInfo[]>;

    updateSellerUser(input: SellerUserInput): Promise<boolean>;

    getSellerUser(stubHubLoginId: string | undefined): Promise<SellerUser>;

    mergeRolesToSellerUser(input: SellerUserRolesInput): Promise<boolean>;

    activateUserForSellerAccountByEmail(email: string | undefined, consigneeSellerAccountId: string | null | undefined): Promise<boolean>;

    activateUserForSellerAccount(input: SellerUserAccountInput): Promise<boolean>;

    deactivateUserForSellerAccount(input: SellerUserAccountInput): Promise<boolean>;

    getSyncCenterSettings(): Promise<SyncCenterSettings>;

    mergeSyncCenterSettings(settings: SyncCenterSettings): Promise<boolean>;

    getAccountAutoPricingSettings(): Promise<AccountAutoPricingSettingsInputs>;

    mergeAccountAutoPricingSettings(input: AccountAutoPricingSettingsInputs): Promise<boolean>;

    getAutoCurrencyConversionSettings(): Promise<AutoCurrencyConversionSettings>;

    mergeAutoCurrencyConversionSettings(settings: AutoCurrencyConversionSettings): Promise<boolean>;

    getCustomTimeZoneSettings(): Promise<TimezoneInfo>;

    mergeCustomTimeZoneSettings(settings: TimezoneInfo | undefined): Promise<boolean>;

    updateMarketplaceSellerAccountPassword(marketplace: Marketplace | undefined, password: string | undefined): Promise<boolean>;

    createSellerRole(input: SellerRoleInput): Promise<PosUiActionResult>;

    updateSellerRole(input: SellerRoleInput): Promise<PosUiActionResult>;

    deleteSellerRole(roleId: number | undefined): Promise<PosUiActionResult>;

    initiateTradeDeskReset(username: string | undefined): Promise<PosUiActionResult>;

    resetTradeDeskPassword(input: TradeDeskPasswordResetInput): Promise<PosUiActionResult>;

    getRevealSyncConfig(): Promise<RevealMarketExternalPosSyncConfig>;

    upsertRevealSyncConfig(syncConfigOverride: RevealSyncConfigOverrideInput): Promise<PosUiActionResult>;

    getConfirmationDialogSettings(): Promise<ConfirmationDialogSettingsResponse>;

    upsertConfirmationDialogSettings(request: ConfirmationDialogSettingRequest): Promise<boolean>;

    getPurchaseOrderSettings(): Promise<PurchaseOrderSettings>;

    mergePurchaseOrderSettings(settings: PurchaseOrderSettings): Promise<boolean>;

    getListingGroupSettings(): Promise<ListingGroupSettings>;

    mergeListingGroupSettings(settings: ListingGroupSettings): Promise<boolean>;

    getAutoBroadcastSettings(): Promise<AutoBroadcastSettings>;

    mergeAutoBroadcastSettings(settings: AutoBroadcastSettings): Promise<boolean>;
}

export class SellerAccountClient extends PosClientBase implements ISellerAccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCurrentUserSellerAccounts(signal?: AbortSignal | undefined): Promise<SellerAccount[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetCurrentUserSellerAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserSellerAccounts(_response);
        });
    }

    protected processGetCurrentUserSellerAccounts(response: Response): Promise<SellerAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccount[]>(null as any);
    }

    getConsigneeSellerAccounts(signal?: AbortSignal | undefined): Promise<SellerAccount[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetConsigneeSellerAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConsigneeSellerAccounts(_response);
        });
    }

    protected processGetConsigneeSellerAccounts(response: Response): Promise<SellerAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccount[]>(null as any);
    }

    getSellerUsersForSellerAccount(signal?: AbortSignal | undefined): Promise<SellerUserAccountInfo[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSellerUsersForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUsersForSellerAccount(_response);
        });
    }

    protected processGetSellerUsersForSellerAccount(response: Response): Promise<SellerUserAccountInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerUserAccountInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerUserAccountInfo[]>(null as any);
    }

    getSelleRolesForSellerAccount(signal?: AbortSignal | undefined): Promise<SellerRoleInfo[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSelleRolesForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelleRolesForSellerAccount(_response);
        });
    }

    protected processGetSelleRolesForSellerAccount(response: Response): Promise<SellerRoleInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerRoleInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerRoleInfo[]>(null as any);
    }

    getAllSellerPermissions(signal?: AbortSignal | undefined): Promise<SellerPermissionInfo[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAllSellerPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSellerPermissions(_response);
        });
    }

    protected processGetAllSellerPermissions(response: Response): Promise<SellerPermissionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerPermissionInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerPermissionInfo[]>(null as any);
    }

    updateSellerUser(input: SellerUserInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpdateSellerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerUser(_response);
        });
    }

    protected processUpdateSellerUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerUser(stubHubLoginId: string | undefined, signal?: AbortSignal | undefined): Promise<SellerUser> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSellerUser?";
        if (stubHubLoginId === null)
            throw new Error("The parameter 'stubHubLoginId' cannot be null.");
        else if (stubHubLoginId !== undefined)
            url_ += "stubHubLoginId=" + encodeURIComponent("" + stubHubLoginId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUser(_response);
        });
    }

    protected processGetSellerUser(response: Response): Promise<SellerUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerUser;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerUser>(null as any);
    }

    mergeRolesToSellerUser(input: SellerUserRolesInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeRolesToSellerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeRolesToSellerUser(_response);
        });
    }

    protected processMergeRolesToSellerUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    activateUserForSellerAccountByEmail(email: string | undefined, consigneeSellerAccountId: string | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/ActivateUserForSellerAccountByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (consigneeSellerAccountId !== undefined && consigneeSellerAccountId !== null)
            url_ += "consigneeSellerAccountId=" + encodeURIComponent("" + consigneeSellerAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateUserForSellerAccountByEmail(_response);
        });
    }

    protected processActivateUserForSellerAccountByEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    activateUserForSellerAccount(input: SellerUserAccountInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/ActivateUserForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateUserForSellerAccount(_response);
        });
    }

    protected processActivateUserForSellerAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deactivateUserForSellerAccount(input: SellerUserAccountInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/DeactivateUserForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateUserForSellerAccount(_response);
        });
    }

    protected processDeactivateUserForSellerAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSyncCenterSettings(signal?: AbortSignal | undefined): Promise<SyncCenterSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSyncCenterSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSyncCenterSettings(_response);
        });
    }

    protected processGetSyncCenterSettings(response: Response): Promise<SyncCenterSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SyncCenterSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncCenterSettings>(null as any);
    }

    mergeSyncCenterSettings(settings: SyncCenterSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeSyncCenterSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeSyncCenterSettings(_response);
        });
    }

    protected processMergeSyncCenterSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccountAutoPricingSettings(signal?: AbortSignal | undefined): Promise<AccountAutoPricingSettingsInputs> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAccountAutoPricingSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountAutoPricingSettings(_response);
        });
    }

    protected processGetAccountAutoPricingSettings(response: Response): Promise<AccountAutoPricingSettingsInputs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountAutoPricingSettingsInputs;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountAutoPricingSettingsInputs>(null as any);
    }

    mergeAccountAutoPricingSettings(input: AccountAutoPricingSettingsInputs, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeAccountAutoPricingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeAccountAutoPricingSettings(_response);
        });
    }

    protected processMergeAccountAutoPricingSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAutoCurrencyConversionSettings(signal?: AbortSignal | undefined): Promise<AutoCurrencyConversionSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAutoCurrencyConversionSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoCurrencyConversionSettings(_response);
        });
    }

    protected processGetAutoCurrencyConversionSettings(response: Response): Promise<AutoCurrencyConversionSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoCurrencyConversionSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoCurrencyConversionSettings>(null as any);
    }

    mergeAutoCurrencyConversionSettings(settings: AutoCurrencyConversionSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeAutoCurrencyConversionSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeAutoCurrencyConversionSettings(_response);
        });
    }

    protected processMergeAutoCurrencyConversionSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomTimeZoneSettings(signal?: AbortSignal | undefined): Promise<TimezoneInfo> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetCustomTimeZoneSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomTimeZoneSettings(_response);
        });
    }

    protected processGetCustomTimeZoneSettings(response: Response): Promise<TimezoneInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimezoneInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimezoneInfo>(null as any);
    }

    mergeCustomTimeZoneSettings(settings: TimezoneInfo | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeCustomTimeZoneSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeCustomTimeZoneSettings(_response);
        });
    }

    protected processMergeCustomTimeZoneSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateMarketplaceSellerAccountPassword(marketplace: Marketplace | undefined, password: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpdateMarketplaceSellerAccountPassword?";
        if (marketplace === null)
            throw new Error("The parameter 'marketplace' cannot be null.");
        else if (marketplace !== undefined)
            url_ += "marketplace=" + encodeURIComponent("" + marketplace) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMarketplaceSellerAccountPassword(_response);
        });
    }

    protected processUpdateMarketplaceSellerAccountPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createSellerRole(input: SellerRoleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/CreateSellerRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSellerRole(_response);
        });
    }

    protected processCreateSellerRole(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateSellerRole(input: SellerRoleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpdateSellerRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerRole(_response);
        });
    }

    protected processUpdateSellerRole(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    deleteSellerRole(roleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/DeleteSellerRole?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSellerRole(_response);
        });
    }

    protected processDeleteSellerRole(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    initiateTradeDeskReset(username: string | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/InitiateTradeDeskReset?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateTradeDeskReset(_response);
        });
    }

    protected processInitiateTradeDeskReset(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    resetTradeDeskPassword(input: TradeDeskPasswordResetInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/ResetTradeDeskPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetTradeDeskPassword(_response);
        });
    }

    protected processResetTradeDeskPassword(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getRevealSyncConfig(signal?: AbortSignal | undefined): Promise<RevealMarketExternalPosSyncConfig> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetRevealSyncConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRevealSyncConfig(_response);
        });
    }

    protected processGetRevealSyncConfig(response: Response): Promise<RevealMarketExternalPosSyncConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevealMarketExternalPosSyncConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevealMarketExternalPosSyncConfig>(null as any);
    }

    upsertRevealSyncConfig(syncConfigOverride: RevealSyncConfigOverrideInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpsertRevealSyncConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertRevealSyncConfig(_response);
        });
    }

    protected processUpsertRevealSyncConfig(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getConfirmationDialogSettings(signal?: AbortSignal | undefined): Promise<ConfirmationDialogSettingsResponse> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetConfirmationDialogSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfirmationDialogSettings(_response);
        });
    }

    protected processGetConfirmationDialogSettings(response: Response): Promise<ConfirmationDialogSettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfirmationDialogSettingsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmationDialogSettingsResponse>(null as any);
    }

    upsertConfirmationDialogSettings(request: ConfirmationDialogSettingRequest, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpsertConfirmationDialogSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertConfirmationDialogSettings(_response);
        });
    }

    protected processUpsertConfirmationDialogSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPurchaseOrderSettings(signal?: AbortSignal | undefined): Promise<PurchaseOrderSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetPurchaseOrderSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderSettings(_response);
        });
    }

    protected processGetPurchaseOrderSettings(response: Response): Promise<PurchaseOrderSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderSettings>(null as any);
    }

    mergePurchaseOrderSettings(settings: PurchaseOrderSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergePurchaseOrderSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePurchaseOrderSettings(_response);
        });
    }

    protected processMergePurchaseOrderSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getListingGroupSettings(signal?: AbortSignal | undefined): Promise<ListingGroupSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetListingGroupSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingGroupSettings(_response);
        });
    }

    protected processGetListingGroupSettings(response: Response): Promise<ListingGroupSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingGroupSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingGroupSettings>(null as any);
    }

    mergeListingGroupSettings(settings: ListingGroupSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeListingGroupSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeListingGroupSettings(_response);
        });
    }

    protected processMergeListingGroupSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAutoBroadcastSettings(signal?: AbortSignal | undefined): Promise<AutoBroadcastSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAutoBroadcastSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoBroadcastSettings(_response);
        });
    }

    protected processGetAutoBroadcastSettings(response: Response): Promise<AutoBroadcastSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoBroadcastSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoBroadcastSettings>(null as any);
    }

    mergeAutoBroadcastSettings(settings: AutoBroadcastSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeAutoBroadcastSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeAutoBroadcastSettings(_response);
        });
    }

    protected processMergeAutoBroadcastSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}
export interface ISellerAccountFulfillmentRulesClient {

    getFulfillmentRuleForEvent(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined): Promise<SellerAccountFulfillmentRuleDto>;

    createFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput): Promise<boolean>;

    deleteFulfillmentRule(fulfillmentRuleId: number | undefined): Promise<boolean>;

    deleteFulfillmentRules(fulfillmentRuleIds: number[]): Promise<boolean>;

    updateFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput): Promise<boolean>;

    createFulfillmentRulesForVenues(input: SellerAccountFulfillmentRulesInput[]): Promise<FileResponse>;

    getVenueLevelFulfillmentRules(): Promise<SellerAccountFulfillmentRule[]>;
}

export class SellerAccountFulfillmentRulesClient extends PosClientBase implements ISellerAccountFulfillmentRulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFulfillmentRuleForEvent(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, signal?: AbortSignal | undefined): Promise<SellerAccountFulfillmentRuleDto> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/GetFulfillmentRuleForEvent?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFulfillmentRuleForEvent(_response);
        });
    }

    protected processGetFulfillmentRuleForEvent(response: Response): Promise<SellerAccountFulfillmentRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountFulfillmentRuleDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountFulfillmentRuleDto>(null as any);
    }

    createFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/CreateFulfillmentRuleForEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFulfillmentRuleForEvent(_response);
        });
    }

    protected processCreateFulfillmentRuleForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteFulfillmentRule(fulfillmentRuleId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/DeleteFulfillmentRule?";
        if (fulfillmentRuleId === null)
            throw new Error("The parameter 'fulfillmentRuleId' cannot be null.");
        else if (fulfillmentRuleId !== undefined)
            url_ += "fulfillmentRuleId=" + encodeURIComponent("" + fulfillmentRuleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFulfillmentRule(_response);
        });
    }

    protected processDeleteFulfillmentRule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteFulfillmentRules(fulfillmentRuleIds: number[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/DeleteFulfillmentRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fulfillmentRuleIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFulfillmentRules(_response);
        });
    }

    protected processDeleteFulfillmentRules(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/UpdateFulfillmentRuleForEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFulfillmentRuleForEvent(_response);
        });
    }

    protected processUpdateFulfillmentRuleForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createFulfillmentRulesForVenues(input: SellerAccountFulfillmentRulesInput[], signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/CreateFulfillmentRulesForVenues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFulfillmentRulesForVenues(_response);
        });
    }

    protected processCreateFulfillmentRulesForVenues(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getVenueLevelFulfillmentRules(signal?: AbortSignal | undefined): Promise<SellerAccountFulfillmentRule[]> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/GetVenueLevelFulfillmentRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueLevelFulfillmentRules(_response);
        });
    }

    protected processGetVenueLevelFulfillmentRules(response: Response): Promise<SellerAccountFulfillmentRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountFulfillmentRule[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountFulfillmentRule[]>(null as any);
    }
}
export interface ISellerSupportCaseClient {

    getSellerSupportCaseNotesByCaseId(sellerSupportCaseId: number | undefined, take: number | null | undefined, skip: number | null | undefined, markAsRead: boolean | null | undefined): Promise<SellerSupportCaseNote[]>;

    getSellerSupportCases(query: SellerSupportCaseQuery, take: number | null | undefined, skip: number | null | undefined): Promise<SellerSupportCase[]>;

    createSellerSupportCase(request: SellerSupportCaseRequest): Promise<number | null>;

    createSellerSupportCaseReply(sellerSupportCaseId: number | undefined, noteContent: string | null | undefined, marketplace: string | null | undefined, attachments: FileParameter[] | null | undefined): Promise<number | null>;

    updateSellerSupportCasesReadDate(sellerSupportCaseIds: number[], readDate: string | null | undefined): Promise<void>;

    retrieveSellerSupportCaseNoteAttachments(attachmentRequests: SellerSupportCaseAttachmentRequest[], retrieveContent: boolean | undefined): Promise<FileDownloadInfo[]>;
}

export class SellerSupportCaseClient extends PosClientBase implements ISellerSupportCaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSellerSupportCaseNotesByCaseId(sellerSupportCaseId: number | undefined, take: number | null | undefined, skip: number | null | undefined, markAsRead: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<SellerSupportCaseNote[]> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/GetSellerSupportCaseNotesByCaseId?";
        if (sellerSupportCaseId === null)
            throw new Error("The parameter 'sellerSupportCaseId' cannot be null.");
        else if (sellerSupportCaseId !== undefined)
            url_ += "sellerSupportCaseId=" + encodeURIComponent("" + sellerSupportCaseId) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (markAsRead !== undefined && markAsRead !== null)
            url_ += "markAsRead=" + encodeURIComponent("" + markAsRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerSupportCaseNotesByCaseId(_response);
        });
    }

    protected processGetSellerSupportCaseNotesByCaseId(response: Response): Promise<SellerSupportCaseNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerSupportCaseNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerSupportCaseNote[]>(null as any);
    }

    getSellerSupportCases(query: SellerSupportCaseQuery, take: number | null | undefined, skip: number | null | undefined, signal?: AbortSignal | undefined): Promise<SellerSupportCase[]> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/GetSellerSupportCases?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerSupportCases(_response);
        });
    }

    protected processGetSellerSupportCases(response: Response): Promise<SellerSupportCase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerSupportCase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerSupportCase[]>(null as any);
    }

    createSellerSupportCase(request: SellerSupportCaseRequest, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/CreateSellerSupportCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSellerSupportCase(_response);
        });
    }

    protected processCreateSellerSupportCase(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    createSellerSupportCaseReply(sellerSupportCaseId: number | undefined, noteContent: string | null | undefined, marketplace: string | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/CreateSellerSupportCaseReply?";
        if (sellerSupportCaseId === null)
            throw new Error("The parameter 'sellerSupportCaseId' cannot be null.");
        else if (sellerSupportCaseId !== undefined)
            url_ += "sellerSupportCaseId=" + encodeURIComponent("" + sellerSupportCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (noteContent !== null && noteContent !== undefined)
            content_.append("NoteContent", noteContent.toString());
        if (marketplace !== null && marketplace !== undefined)
            content_.append("Marketplace", marketplace.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSellerSupportCaseReply(_response);
        });
    }

    protected processCreateSellerSupportCaseReply(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    updateSellerSupportCasesReadDate(sellerSupportCaseIds: number[], readDate: string | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/UpdateSellerSupportCasesReadDate?";
        if (readDate !== undefined && readDate !== null)
            url_ += "readDate=" + encodeURIComponent("" + readDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellerSupportCaseIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerSupportCasesReadDate(_response);
        });
    }

    protected processUpdateSellerSupportCasesReadDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    retrieveSellerSupportCaseNoteAttachments(attachmentRequests: SellerSupportCaseAttachmentRequest[], retrieveContent: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileDownloadInfo[]> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/RetrieveSellerSupportCaseNoteAttachments?";
        if (retrieveContent === null)
            throw new Error("The parameter 'retrieveContent' cannot be null.");
        else if (retrieveContent !== undefined)
            url_ += "retrieveContent=" + encodeURIComponent("" + retrieveContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetrieveSellerSupportCaseNoteAttachments(_response);
        });
    }

    protected processRetrieveSellerSupportCaseNoteAttachments(response: Response): Promise<FileDownloadInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileDownloadInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDownloadInfo[]>(null as any);
    }
}
export interface ISellerUserClient {

    getSellerUserSetting(userSetting: UserSetting | undefined, currentLoginUserOnly: boolean | undefined): Promise<SellerUserSetting>;

    getSellerUserSettings(userSettings: UserSetting[], currentLoginUserOnly: boolean | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }>;

    getAllSellerUserSettings(exceptUserSettings: UserSetting[] | undefined, currentLoginUserOnly: boolean | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }>;

    setSellerUserSetting(userSetting: UserSetting | undefined, userSettingValue: string, currentLoginUserOnly: boolean | undefined): Promise<boolean>;

    getCustomInventoryQuickFiltersSetting(): Promise<CustomQuickFilterOfListingQuery[] | null>;

    setCustomInventoryQuickFiltersSetting(value: CustomQuickFilterOfListingQuery[]): Promise<boolean>;

    getCustomOnSaleEventQuickFiltersSetting(): Promise<CustomQuickFilterOfOnSaleEventQuery[] | null>;

    setCustomOnSaleEventQuickFiltersSetting(value: CustomQuickFilterOfOnSaleEventQuery[]): Promise<boolean>;

    getCustomSalesQuickFiltersSetting(): Promise<CustomQuickFilterOfSaleQuery[] | null>;

    setCustomSalesQuickFiltersSetting(value: CustomQuickFilterOfSaleQuery[]): Promise<boolean>;

    getCustomPurchasesQuickFiltersSetting(): Promise<CustomQuickFilterOfPurchaseOrderQuery[] | null>;

    setCustomPurchasesQuickFiltersSetting(value: CustomQuickFilterOfPurchaseOrderQuery[]): Promise<boolean>;

    getCustomMarketplacePaymentsQuickFiltersSetting(): Promise<CustomQuickFilterOfMarketplacePaymentQuery[] | null>;

    setCustomMarketplacePaymentsQuickFiltersSetting(value: CustomQuickFilterOfMarketplacePaymentQuery[]): Promise<boolean>;

    getAvailableReleaseNoteInfos(currentLoginUserOnly: boolean | undefined, getUnreadOnly: boolean | undefined): Promise<ReleaseNote[]>;

    getHasReleaseNotesUnread(currentLoginUserOnly: boolean | undefined): Promise<boolean>;

    getReleaseNoteHtmlByReleaseNoteIds(currentLoginUserOnly: boolean | undefined, releaseNoteIds: number[]): Promise<ReleaseNote[]>;

    getAllTutorialItems(currentLoginUserOnly: boolean | undefined): Promise<TutorialItem[]>;

    getTutorialItemContents(tutorialItemIds: number[]): Promise<TutorialItemContent[]>;

    getSellerEventConfirmationDialogSuppressions(viagogoVirtualId: string | undefined): Promise<SellerEventConfirmationDialogSuppression[]>;

    getSellerEventConfirmationDialogSuppressionsByEventIds(viagogoVirtualIds: string[]): Promise<SellerEventConfirmationDialogSuppression[]>;

    insertSellerEventConfirmationDialogSuppression(request: InsertSellerEventConfirmationDialogSuppressionRequest): Promise<PosActionResult>;
}

export class SellerUserClient extends PosClientBase implements ISellerUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSellerUserSetting(userSetting: UserSetting | undefined, currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<SellerUserSetting> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerUserSetting?";
        if (userSetting === null)
            throw new Error("The parameter 'userSetting' cannot be null.");
        else if (userSetting !== undefined)
            url_ += "userSetting=" + encodeURIComponent("" + userSetting) + "&";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUserSetting(_response);
        });
    }

    protected processGetSellerUserSetting(response: Response): Promise<SellerUserSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerUserSetting;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerUserSetting>(null as any);
    }

    getSellerUserSettings(userSettings: UserSetting[], currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerUserSettings?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUserSettings(_response);
        });
    }

    protected processGetSellerUserSettings(response: Response): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof UserSetting]?: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof UserSetting]?: string; }>(null as any);
    }

    getAllSellerUserSettings(exceptUserSettings: UserSetting[] | undefined, currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        let url_ = this.baseUrl + "/api/SellerUser/GetAllSellerUserSettings?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exceptUserSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSellerUserSettings(_response);
        });
    }

    protected processGetAllSellerUserSettings(response: Response): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof UserSetting]?: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof UserSetting]?: string; }>(null as any);
    }

    setSellerUserSetting(userSetting: UserSetting | undefined, userSettingValue: string, currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetSellerUserSetting?";
        if (userSetting === null)
            throw new Error("The parameter 'userSetting' cannot be null.");
        else if (userSetting !== undefined)
            url_ += "userSetting=" + encodeURIComponent("" + userSetting) + "&";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettingValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSellerUserSetting(_response);
        });
    }

    protected processSetSellerUserSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomInventoryQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfListingQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomInventoryQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomInventoryQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomInventoryQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfListingQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfListingQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfListingQuery[] | null>(null as any);
    }

    setCustomInventoryQuickFiltersSetting(value: CustomQuickFilterOfListingQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomInventoryQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomInventoryQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomInventoryQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomOnSaleEventQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfOnSaleEventQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomOnSaleEventQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomOnSaleEventQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomOnSaleEventQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfOnSaleEventQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfOnSaleEventQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfOnSaleEventQuery[] | null>(null as any);
    }

    setCustomOnSaleEventQuickFiltersSetting(value: CustomQuickFilterOfOnSaleEventQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomOnSaleEventQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomOnSaleEventQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomOnSaleEventQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomSalesQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfSaleQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomSalesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomSalesQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomSalesQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfSaleQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfSaleQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfSaleQuery[] | null>(null as any);
    }

    setCustomSalesQuickFiltersSetting(value: CustomQuickFilterOfSaleQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomSalesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomSalesQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomSalesQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomPurchasesQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfPurchaseOrderQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomPurchasesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomPurchasesQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomPurchasesQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfPurchaseOrderQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfPurchaseOrderQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfPurchaseOrderQuery[] | null>(null as any);
    }

    setCustomPurchasesQuickFiltersSetting(value: CustomQuickFilterOfPurchaseOrderQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomPurchasesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomPurchasesQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomPurchasesQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomMarketplacePaymentsQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfMarketplacePaymentQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomMarketplacePaymentsQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomMarketplacePaymentsQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomMarketplacePaymentsQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfMarketplacePaymentQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfMarketplacePaymentQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfMarketplacePaymentQuery[] | null>(null as any);
    }

    setCustomMarketplacePaymentsQuickFiltersSetting(value: CustomQuickFilterOfMarketplacePaymentQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomMarketplacePaymentsQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomMarketplacePaymentsQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomMarketplacePaymentsQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableReleaseNoteInfos(currentLoginUserOnly: boolean | undefined, getUnreadOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<ReleaseNote[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetAvailableReleaseNoteInfos?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        if (getUnreadOnly === null)
            throw new Error("The parameter 'getUnreadOnly' cannot be null.");
        else if (getUnreadOnly !== undefined)
            url_ += "getUnreadOnly=" + encodeURIComponent("" + getUnreadOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableReleaseNoteInfos(_response);
        });
    }

    protected processGetAvailableReleaseNoteInfos(response: Response): Promise<ReleaseNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleaseNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseNote[]>(null as any);
    }

    getHasReleaseNotesUnread(currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/GetHasReleaseNotesUnread?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHasReleaseNotesUnread(_response);
        });
    }

    protected processGetHasReleaseNotesUnread(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getReleaseNoteHtmlByReleaseNoteIds(currentLoginUserOnly: boolean | undefined, releaseNoteIds: number[], signal?: AbortSignal | undefined): Promise<ReleaseNote[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetReleaseNoteHtmlByReleaseNoteIds?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(releaseNoteIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleaseNoteHtmlByReleaseNoteIds(_response);
        });
    }

    protected processGetReleaseNoteHtmlByReleaseNoteIds(response: Response): Promise<ReleaseNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleaseNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseNote[]>(null as any);
    }

    getAllTutorialItems(currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<TutorialItem[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetAllTutorialItems?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTutorialItems(_response);
        });
    }

    protected processGetAllTutorialItems(response: Response): Promise<TutorialItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TutorialItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorialItem[]>(null as any);
    }

    getTutorialItemContents(tutorialItemIds: number[], signal?: AbortSignal | undefined): Promise<TutorialItemContent[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetTutorialItemContents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tutorialItemIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTutorialItemContents(_response);
        });
    }

    protected processGetTutorialItemContents(response: Response): Promise<TutorialItemContent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TutorialItemContent[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorialItemContent[]>(null as any);
    }

    getSellerEventConfirmationDialogSuppressions(viagogoVirtualId: string | undefined, signal?: AbortSignal | undefined): Promise<SellerEventConfirmationDialogSuppression[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerEventConfirmationDialogSuppressions?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventConfirmationDialogSuppressions(_response);
        });
    }

    protected processGetSellerEventConfirmationDialogSuppressions(response: Response): Promise<SellerEventConfirmationDialogSuppression[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventConfirmationDialogSuppression[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventConfirmationDialogSuppression[]>(null as any);
    }

    getSellerEventConfirmationDialogSuppressionsByEventIds(viagogoVirtualIds: string[], signal?: AbortSignal | undefined): Promise<SellerEventConfirmationDialogSuppression[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerEventConfirmationDialogSuppressionsByEventIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viagogoVirtualIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventConfirmationDialogSuppressionsByEventIds(_response);
        });
    }

    protected processGetSellerEventConfirmationDialogSuppressionsByEventIds(response: Response): Promise<SellerEventConfirmationDialogSuppression[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventConfirmationDialogSuppression[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventConfirmationDialogSuppression[]>(null as any);
    }

    insertSellerEventConfirmationDialogSuppression(request: InsertSellerEventConfirmationDialogSuppressionRequest, signal?: AbortSignal | undefined): Promise<PosActionResult> {
        let url_ = this.baseUrl + "/api/SellerUser/InsertSellerEventConfirmationDialogSuppression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertSellerEventConfirmationDialogSuppression(_response);
        });
    }

    protected processInsertSellerEventConfirmationDialogSuppression(response: Response): Promise<PosActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosActionResult>(null as any);
    }
}
